import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const skeletonDefaultVariants = {
  "variant": "rectangle",
  "shouldAnimate": true
}
const skeletonCompoundVariants = []

const skeletonSlotNames = [
  [
    "wrapper",
    "Skeleton__wrapper"
  ],
  [
    "skeleton",
    "Skeleton__skeleton"
  ]
]
const skeletonSlotFns = /* @__PURE__ */ skeletonSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, skeletonDefaultVariants, getSlotCompoundVariant(skeletonCompoundVariants, slotName))])

const skeletonFn = memo((props = {}) => {
  return Object.fromEntries(skeletonSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const skeletonVariantKeys = [
  "variant",
  "shouldAnimate"
]
const getVariantProps = (variants) => ({ ...skeletonDefaultVariants, ...compact(variants) })

export const skeleton = /* @__PURE__ */ Object.assign(skeletonFn, {
  __recipe__: false,
  __name__: 'skeleton',
  raw: (props) => props,
  variantKeys: skeletonVariantKeys,
  variantMap: {
  "variant": [
    "rectangle",
    "round"
  ],
  "shouldAnimate": [
    "false",
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, skeletonVariantKeys)
  },
  getVariantProps
})